export enum FiltersYesNo {
    ALL = '',
    YES = 'yes',
    NO = 'no',
}